import {
    Edit,
    SimpleForm,
    TextInput,
    useRecordContext,
    required,
    SelectInput,
    BooleanInput,
    minValue,
    NumberInput,
} from 'react-admin';
import { Subjects } from '../../custom';
import FileUpload from '../../common/inputs/FileUpload';
import { EditToolbar } from '../../common/EditToolbar';

import { useParams } from 'react-router';
import { LoadingSection } from '../../common/LoadingSection';
import { STATUSES, TEST_SERIES_TYPES } from '../../common/constants';
import HTMLEditorInput, { validHtml } from '../../common/inputs/HTMLEditorInput';
import SlugInput from '../../common/inputs/SlugInput';
import { ProgramAutocomplete } from '../../common/inputs/autoCompleteInputs/ProgramAutoComplete';

const TestSeriesEdit = () => {
    let { id } = useParams();
    if (!id) {
        return <LoadingSection />;
    }
    return (
        <Edit
            mutationMode={'pessimistic'}
            title={<TestSeriesTitle />}
            redirect={() => {
                return `test-series`;
            }}
            resource={'test-series'}
            id={id}
        >
            <SimpleForm toolbar={<EditToolbar />}>
                <FileUpload type="VIDEO_THUMBNAIL" source="image" accept={'image/*'} />
                <TextInput source="title" fullWidth validate={[required()]} />
                <SlugInput source="slug" fullWidth />
                <BooleanInput source={'isDemo'} defaultValue={false} />
                <NumberInput source="displayOrder" fullWidth validate={[minValue(1)]} />
                <ProgramAutocomplete alwaysOn />
                <SelectInput
                    source="status"
                    label={'Status'}
                    fullWidth
                    validate={[required()]}
                    choices={STATUSES}
                />
                <SelectInput
                    source="type"
                    label={'Type'}
                    fullWidth
                    defaultValue={'REGULAR'}
                    validate={[required()]}
                    choices={TEST_SERIES_TYPES}
                />
                <TextInput source="textDescription" fullWidth validate={[required()]} />
                <HTMLEditorInput
                    source={'htmlDescription'}
                    fullWidth
                    validate={[required(), validHtml]}
                />
            </SimpleForm>
        </Edit>
    );
};

const TestSeriesTitle = () => {
    const record = useRecordContext<Subjects>();

    return record ? <span>{record.name}</span> : null;
};

export default TestSeriesEdit;
